export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

export const meta = {
  alias: process.env.APP_MANIFEST?.alias ?? 'audio-player',
  name: process.env.APP_MANIFEST?.name ?? 'Audio Player'
} as const;
